import { render, staticRenderFns } from "./groupPerson.vue?vue&type=template&id=04dda25c&"
import script from "./groupPerson.vue?vue&type=script&lang=js&"
export * from "./groupPerson.vue?vue&type=script&lang=js&"
import style0 from "./groupPerson.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports